export default {
  GET_OWNER_HOUSE_PROPERTY_MORE: "/api/v1/owner-house-property",
  GET_OWNER_HOUSE_PROPERTY_ANALYZE: "/api/v1/owner-house-property/analyze",

  POST_OWNER_HOUSE_PROPERTY_SEARCH: "/api/v1/owner-house-property",
};
